<template>
  <div class="row">
    <div class="col-md-12">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__body">
          <!-- <span class="loading-request" v-show="loading"></span> -->
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
          >
            <h5>
              Relatório do Cliente
              <span class="font-weight-bold" v-if="data.group">{{ data.group.name }}</span> <br />
              <small v-if="filters.billing_month"
                >referente ao mês {{ filters.billing_month }}</small
              >
            </h5>
            <div class="btn-toolbar mb-2 mb-md-0">
              <div class="btn-group d-print-none mr-2">
                <SelectInvoiceBillingMonth
                  :selected="filters.billing_month"
                  :first="'Mês do faturamento'"
                  @change="setFilter('billing_month', $event)"
                  class="mr-2"
                  v-b-tooltip.hover
                  title="Selecione o mês de faturamento"
                />

                <a class="mr-2" href data-toggle="modal" @click="callData()">
                  <button class="btn btn-outline-brand m-btn m-btn--outline">
                    <i class="fas fa-sync-alt"></i> Gerar novo
                  </button>
                </a>

                <a href data-toggle="modal" onclick="window.print();return false;">
                  <button class="btn btn-outline-brand m-btn m-btn--outline">
                    <i class="fas fa-print"></i> Imprimir
                  </button>
                </a>
              </div>

              <div class="d-none d-print-block pt-0 mt-0">
                <div class="m-invoice__logo">
                  <a href="#">
                    <img src="@/assets/media/img/logo/logo_newway.svg" width="200" />
                  </a>
                </div>
                <span class="m-invoice__desc">
                  <span class="text-right mr-1">CNPJ: 17.738.064/0001-97 </span>
                </span>
              </div>
            </div>
          </div>

          <div
            id="alert"
            class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
            :class="alert.color"
            role="alert"
            v-if="alert.message"
          >
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="alert.message = ''"
            ></button>
            <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
            ><br />
            {{ alert.reason }}
          </div>

          <div v-if="data.group">
            <div class="table-responsive">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom"
              >
                <h5 class="mt-5 font-weight-bold">Empresas</h5>
              </div>

              <div class="container-table mb-3 mt-3">
                <div class="table-responsive">
                  <table class="table m-table table-striped">
                    <thead>
                      chatbot_chatbot_protocolo
                      <tr>
                        <th class="text-left font-weight-bold">Razao Social</th>
                        <th class="text-left font-weight-bold">Nome Fantasia</th>
                        <th class="text-left font-weight-bold">CNPJ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="company in data.companies" :key="company.id">
                        <td class="text-left">{{ company.co_name }}</td>
                        <td class="text-left">{{ company.name }}</td>
                        <td class="text-left">{{ company.cnpj }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h5 class="mt-5 font-weight-bold">Usuários</h5>
              </div>

              <div v-for="company in data.companies" :key="company.id">
                <div v-if="company.users.length">
                  <div class="container-table mb-3 mt-3">
                    <h6 class="pt-3 pb-0"><strong>Empresa:</strong> {{ company.name }}</h6>
                    <div v-if="company.users.length" class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-left font-weight-bold">Usuário</th>
                            <th class="text-left font-weight-bold">Email</th>
                            <th class="text-left font-weight-bold">Permissão</th>
                            <th class="text-center font-weight-bold">Criado em</th>
                            <th class="text-center font-weight-bold">Dias inativos</th>
                            <th class="text-center font-weight-bold">Dias ativos</th>
                            <th class="text-right font-weight-bold">Preço Licença</th>
                            <th class="text-right font-weight-bold">Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="user in company.users" :key="user.id">
                            <td class="text-left">{{ user.user }}</td>
                            <td class="text-left">{{ user.login }}</td>
                            <td class="text-left">{{ user.type == 0 ? 'Operador' : 'Gestor' }}</td>
                            <td class="text-center">{{ user.created | date }}</td>
                            <td class="text-center">
                              {{ user.inactivity ? user.inactivity : '-' }}
                            </td>
                            <td class="text-center">{{ user.days_to_pay }}</td>
                            <td class="text-right">{{ user.price_licence | money }}</td>
                            <td class="text-right">{{ user.total | money }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom"
              >
                <h5 class="mt-5"><strong>Descrição do produto contratado</strong> MKTZAP</h5>
              </div>

              <div
                class="container-table mb-3 mt-3"
                v-for="company in data.companies"
                :key="company.id"
              >
                <h6 class="pt-3 pb-2" v-if="company.details.length">
                  <strong>Empresa:</strong> {{ company.name }}
                </h6>
                <div v-if="company.details.length" class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold">Modelo</th>
                        <th class="text-center font-weight-bold">Quantidade</th>
                        <th class="text-right font-weight-bold">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="detail in company.details" :key="detail.id">
                        <td class="text-left">{{ detail.type }}</td>
                        <td class="text-center">{{ detail.amount }}</td>
                        <td class="text-right">{{ detail.total | money }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom"
              >
                <h5 class="mt-5 font-weight-bold">Total</h5>
              </div>
              <div class="container-table mb-3 mt-3">
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-right font-weight-bold">Descrição</th>
                        <th class="text-right font-weight-bold" width="200">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-right">Subtotal:</td>
                        <td class="text-right">{{ data.details_price | money }}</td>
                      </tr>
                      <tr v-if="data.group.minimal">
                        <td class="text-right">Valor mínimo:</td>
                        <td class="text-right">{{ data.group.minimal | money }}</td>
                      </tr>
                      <tr v-if="data.price_extra">
                        <td class="text-right">Adicional:</td>
                        <td class="text-right">{{ data.price_extra | money }}</td>
                      </tr>
                      <tr v-if="data.discount">
                        <td class="text-right">Desconto:</td>
                        <td class="text-right">{{ data.discount | money }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td class="text-right font-weight-bold">TOTAL:</td>
                        <td class="text-right font-weight-bold">{{ data.total | money }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInvoiceBillingMonth from '@/components/forms/SelectInvoiceBillingMonth';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'ReportInvoiceGroup',
  components: { SelectInvoiceBillingMonth },
  data() {
    return {
      data: {},
      filters: {
        id: '',
        billing_month: '',
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      loading: false,
    };
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    callData() {
      this.getDatas();
    },
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    getDatas() {
      this.data = {};

      const url = `${baseApiUrl}/v1/report/invoice/group`;
      axios.post(url, this.filters).then((res) => {
        if (res.data.status === 200) {
          this.clearAlert();
          this.data = res.data.data;
        } else {
          this.alert = {
            color: 'alert-danger',
            icon: 'fas fa-exclamation-triangle fa-lg',
            message: res.data.message,
            reason: '',
          };
        }
      });
    },
  },
  beforeMount() {
    this.filters.id = this.$route.params.groupId ? this.$route.params.groupId : '';
    if (this.$route.params.month && this.$route.params.year) {
      this.filters.billing_month = `${this.$route.params.month}/${this.$route.params.year}`;
    }
  },
  mounted() {
    if (this.filters.id && this.filters.billing_month) {
      this.callData();
    } else {
      this.alert = {
        color: 'alert-brand',
        icon: 'fas fa-exclamation-triangle fa-lg',
        message: 'Selecione a Carteira e Mês de faturamento para gerar o relatório...',
        reason: '',
      };
    }
  },
};
</script>

<style scoped>
.search-voucher-button {
  margin: 25px 0;
}

.used-voucher {
  color: ccc;
  font-size: 12px;
  font-style: italic;
}

.voucher-info-key {
  font-weight: 500;
  margin-bottom: 5px;
}
</style>
